import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5de2b1c3&lang=pug&"
import script from "./list.vue?vue&type=script&lang=coffee&"
export * from "./list.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksCommons: require('/opt/build/repo/nuxt-app/components/globals/blocks/commons.coffee').default})
